/**
 * Used to create the notification order of observers. Note HIGHER priority means a lower number,
 * such that the item will be placed earlier in the queue to notify.
 */ export var ObserverPriority = /*#__PURE__*/ function(ObserverPriority) {
    ObserverPriority[ObserverPriority["HIGH"] = 0] = "HIGH";
    ObserverPriority[ObserverPriority["NORMAL"] = 1] = "NORMAL";
    ObserverPriority[ObserverPriority["LOW"] = 2] = "LOW";
    return ObserverPriority;
}({});

//# sourceMappingURL=observable.enums.js.map